import { Hero } from "@/components/Hero";
import { MembersServices, MembersTestimonials } from "@/components/ServicesSection";
import { ChatSection } from "@/components/ChatSection";
import { PredictionsTeaser } from "@/components/PredictionsTeaser";
import { CommentsSection } from "@/components/CommentsSection";
import { PaymentSection } from "@/components/PaymentSection";
import { Footer } from "@/components/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="relative">
      <Hero />
      <MembersServices />
      <ChatSection />
      <PredictionsTeaser />
      <MembersTestimonials><CommentsSection /></MembersTestimonials>
      <PaymentSection />
      <Footer />
    </div>
  );
}
